<ng-content select="fui-attributed-list-entry"></ng-content>


